export const SHAKEY = 'Tectoro@123_SSH';

export const adminRoleID = 1;
export const SupportRoleID = 2;
